import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'micro-i18n';
import { IconShare } from 'components/icons/Icons';
import { JotType } from 'consts';
import { connect } from 'unistore/preact';
import { actions } from 'actions';
import { getDeckState, isNullOrUndefOrEmpty } from 'utils';
import classNames from 'classnames';

const ShareModalButton = ({
  onToggleModal,
  widgetState,
  questionsData = {},
  questionIndex,
  showModal = false,
  modalId,
  shareableLink,
  className,
  focusRef,
  jot
}) => {
  if (isNullOrUndefOrEmpty(onToggleModal) || isNullOrUndefOrEmpty(modalId) || isNullOrUndefOrEmpty(focusRef)) {
    return null;
  }

  const { currentQuestion } = getDeckState({
    widgetState, questionsData, questionIndex
  });

  const isShareable = !isNullOrUndefOrEmpty(currentQuestion) && !isNullOrUndefOrEmpty(shareableLink);

  const handleToggleShareModal = () => {
    jot({ space: 'poll', type: JotType.ShareClick, question: currentQuestion });
    onToggleModal();
  };

  return (
    isShareable ? <button
      role="button"
      type="button"
      ref={focusRef}
      onClick={handleToggleShareModal}
      className={classNames('csw-btn csw-share-modal-btn outline', className)}
      aria-expanded={showModal}
      aria-haspopup="true"
      aria-controls={modalId}
      title={i18n.t('SHARE')}
      aria-label={i18n.t('SHARE')}>
      <span className="csw-btn-txt sr-only">{i18n.t('SHARE')}</span>
      <IconShare iconClassName="csw-icon-sm" />
    </button> : null
  );
};

ShareModalButton.propTypes = {
  onToggleModal: PropTypes.func.isRequired,
  widgetState: PropTypes.number,
  questionsData: PropTypes.object,
  questionIndex: PropTypes.number,
  showModal: PropTypes.bool,
  modalId: PropTypes.string.isRequired,
  shareableLink: PropTypes.object,
  className: PropTypes.string,
  focusRef: PropTypes.object.isRequired,
  jot: PropTypes.func,
};

export default connect('widgetState,questionsData,questionIndex,shareableLink', actions)(ShareModalButton);
